import request from 'local_modules/request'
import { reducers } from 'redux/core'
import { constants } from 'helpers'


const fetch = () => {
  return request.get(constants.voting.getUser)
    .then(({ data }) => data)
    .then((userData) => {
      reducers.voting.accessLevel.set({
        ...userData,
        isAdmin: userData.type === 2
      })
    })
    .catch((error) => {
      reducers.voting.accessLevel.set({
        isAdmin: false,
      })
    })
}


export default {
  fetch,
}
